// Components/Sidebar.js
import "./Sidebar.css"
import React from 'react';
import Logo from "../Pictures/logo.png";
import Settings from "../Pictures/Icons/settings_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg";
import History from "../Pictures/Icons/history_book_4_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg";
import Assets from "../Pictures/Icons/asset_24dp.svg";
import FitMap from "../Pictures/Icons/fit_map_filter_center_focus_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg";

const Sidebar = ({
                     onFitMap,
                     onToggleSection,
                     activeSetting,
                     showSettingsMenu,
                     contentMap
                 }) => {
    return (
        <>
            <div className="sidebar left">
                <img src={Logo} alt="Logo" style={{ width: '10vw', height: 'auto' }} />
                <button className="sidebar-btn" onClick={onFitMap}>
                    <img src={FitMap} alt="Fit Map" style={{ width: '40px', height: 'auto' }} />
                    Fit Map
                </button>

                <div className="sidebar_bottom_div">
                    <button
                        className={`sidebar-btn${activeSetting === 'history' ? ' active' : ''}`}
                        onClick={() => onToggleSection('history')}
                    >
                        <img src={History} alt="History" style={{ width: '40px', height: 'auto' }} />
                        History
                    </button>
                    <button
                        className={`sidebar-btn${activeSetting === 'assets' ? ' active' : ''}`}
                        onClick={() => onToggleSection('assets')}
                    >
                        <img src={Assets} alt="Assets" style={{ width: '40px', height: 'auto' }} />
                        Assets
                    </button>
                    <button
                        className={`sidebar-btn${activeSetting === 'settings' ? ' active' : ''}`}
                        onClick={() => onToggleSection('settings')}
                    >
                        <img src={Settings} alt="Settings" style={{ width: '40px', height: 'auto' }} />
                        Settings
                    </button>

                    <div className="spacer" />
                </div>
            </div>

            {showSettingsMenu && (
                <div className="sidebar middle">
                    {contentMap?.[activeSetting] || 'Work in progress...'}
                </div>
            )}
         </>
    );}


export default Sidebar;
